var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-bar"},[_c('div',{staticClass:"charts-box"},[_c('div',{staticClass:"myChart-Work-box",attrs:{"id":("myChart-Work-" + _vm.projectID)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }